import type { TabsProps } from "@jana-technology/platform-ui";
import {
  CONFIG_ATTRIBUTE_MAPPING_ROUTE,
  CONFIG_DISPLAY_OPTIONS_ROUTE,
  CONFIG_IMPORT_ROUTE,
  OVERVIEW_ROUTE_CHARTS,
  OVERVIEW_ROUTE_CHARTS_INTERVENTION,
  OVERVIEW_ROUTE_CHARTS_OPERATIONAL,
  OVERVIEW_ROUTE_MAP,
  OVERVIEW_ROUTE_MAP_HYBRID,
  OVERVIEW_ROUTE_MAP_SATELLITE,
  OVERVIEW_ROUTE_TABLES,
  OVERVIEW_ROUTE_TABLES_KCF,
  OVERVIEW_ROUTE_TABLES_KLF,
  OVERVIEW_ROUTE_TABLES_RISK,
  OVERVIEW_ROUTE_TABLES_WELL,
  RISK_ROUTE_CHARTS,
  RISK_ROUTE_CHARTS_MAJOR,
  RISK_ROUTE_CHARTS_OVERALL,
  RISK_ROUTE_TABLES,
} from "constants/routing";

export const overviewPrimaryTabs = [
  {
    label: "Charts",
    id: "charts",
    link: OVERVIEW_ROUTE_CHARTS,
  },
  {
    label: "Data Table",
    id: "tables",
    link: OVERVIEW_ROUTE_TABLES,
  },
  {
    label: "Map",
    id: "map",
    link: OVERVIEW_ROUTE_MAP,
  },
] satisfies TabsProps["items"];

export const overviewSecondaryChartsTabs = [
  {
    label: "Operational Risk",
    id: "operational",
    link: OVERVIEW_ROUTE_CHARTS_OPERATIONAL,
  },
  {
    label: "Intervention Risk",
    id: "intervention",
    link: OVERVIEW_ROUTE_CHARTS_INTERVENTION,
  },
] satisfies TabsProps["items"];

export const overviewSecondaryTablesTabs = [
  {
    label: "Well Attributes",
    id: "wellAttributes",
    link: OVERVIEW_ROUTE_TABLES_WELL,
  },
  {
    label: "Risk",
    id: "riskSummaries",
    link: OVERVIEW_ROUTE_TABLES_RISK,
  },
  {
    label: "Key Likelihood Factors",
    id: "keyLikelihoodFactors",
    link: OVERVIEW_ROUTE_TABLES_KLF,
  },
  {
    label: "Key Consequence Factors",
    id: "keyConsequenceFactors",
    link: OVERVIEW_ROUTE_TABLES_KCF,
  },
] satisfies TabsProps["items"];

export const overviewSecondaryMapTabs = [
  {
    label: "Hybrid",
    id: "hybrid",
    link: OVERVIEW_ROUTE_MAP_HYBRID,
  },
  {
    label: "Satellite",
    id: "satellite",
    link: OVERVIEW_ROUTE_MAP_SATELLITE,
  },
] satisfies TabsProps["items"];

export const riskPrimaryTabs = [
  {
    label: "Charts",
    id: "charts",
    link: RISK_ROUTE_CHARTS,
  },
  {
    label: "Data Table",
    id: "tables",
    link: RISK_ROUTE_TABLES,
  },
] satisfies TabsProps["items"];

export const riskSecondaryChartsTabs = [
  {
    label: "Overall Risk",
    id: "overall",
    link: RISK_ROUTE_CHARTS_OVERALL,
  },
  {
    label: "Major Event Risk",
    id: "major",
    link: RISK_ROUTE_CHARTS_MAJOR,
  },
] satisfies TabsProps["items"];

export const configLhTabs = [
  {
    label: "Import Data",
    id: "importData",
    link: CONFIG_IMPORT_ROUTE,
  },
  {
    label: "Attribute Mapping",
    id: "attributeMapping",
    link: CONFIG_ATTRIBUTE_MAPPING_ROUTE,
  },
  {
    label: "Display Options",
    id: "displayOptions",
    link: CONFIG_DISPLAY_OPTIONS_ROUTE,
  },
] satisfies TabsProps["items"];
